import * as React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import { Icon, IconButton } from '@material-ui/core';
var BookDemoDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, classes = _a.classes;
    return (React.createElement(Dialog, { open: open, onClose: onClose, maxWidth: false, "aria-labelledby": "confirm-dialog" },
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(IconButton, { className: classes.closeButton, onClick: onClose },
                React.createElement(Icon, null, "clear")),
            React.createElement("iframe", { src: "https://outlook.office365.com/owa/calendar/RequestDemo@launchpeople.com/bookings/", width: "1050", height: "700", scrolling: "yes" }))));
};
var styles = {
    content: {
        width: 1050,
        minHeight: 700,
        padding: 0,
        paddingTop: '5px !important',
    },
    closeButton: {
        float: 'right',
        marginRight: 15,
    },
};
export default withStyles(styles)(BookDemoDialog);



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/BookDemoDialog.tsx
// module id = 811
// module chunks = 81